import React from 'react';
import {graphql} from 'gatsby';
import {DiscussionEmbed} from 'disqus-react';

import Layout from '../components/layout';
import Seo from '../components/seo';
import PostNavs from '../components/post-navs';

import {BlogPostPageContext} from '../gatsby/create-pages';
import {PageProps, SupportedLanguage} from '../types';

import '../styles/post.css';
import PostDates from '../components/post-dates';

type Props = PageProps & BlogPostPageContext & BlogPostTemplateQueryResult;
function BlogPostTemplate({location, data, pageContext}: Props) {
	const post = data.markdownRemark;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	const {lang, title, description, date, disqus_id, updated_at} =
		post.frontmatter;
	const {
		siteUrl,
		siteTitle: {[lang]: siteTitle},
	} = data.site.siteMetadata;
	const {previous, next, slug} = pageContext;

	return (
		<Layout location={location} title={siteTitle} lang={lang}>
			<Seo
				lang={lang}
				title={title}
				description={description || post.excerpt}
			/>

			<article className="Post">
				<header className="Header">
					<h1 className="Title">{title}</h1>
					<PostDates
						lang={lang}
						date={date}
						updated_at={updated_at}
					/>
				</header>

				<section
					className="Content"
					dangerouslySetInnerHTML={{__html: post.html}}
				/>

				<DiscussionEmbed
					shortname="bader-nasser"
					config={{
						title,
						url: siteUrl + slug,
						identifier: disqus_id,
						language: lang,
					}}
				/>
			</article>

			<PostNavs previous={previous} next={next} lang={lang} />
		</Layout>
	);
}

export default BlogPostTemplate;

interface BlogPostTemplateQueryResult {
	data: {
		site: {
			siteMetadata: {
				siteTitle: {
					ar: string;
					en: string;
				};
				siteUrl: string;
			};
		};
		markdownRemark: {
			html: string;
			excerpt: string;
			frontmatter: {
				title: string;
				date: string;
				description: string;
				lang: SupportedLanguage;
				disqus_id: string;
				updated_at: string;
			};
		};
	};
}

export const pageQuery = graphql`
	query BlogPostBySlug($slug: String!) {
		site {
			siteMetadata {
				siteTitle {
					ar
					en
				}
				siteUrl
			}
		}
		markdownRemark(fields: {slug: {eq: $slug}}) {
			id
			excerpt(pruneLength: 160)
			html
			frontmatter {
				title
				lang
				date
				description
				disqus_id
				updated_at
			}
		}
	}
`;
